import * as actions from '../actions';
import {
    getCollection
} from '../../constant';

export const createNotification = (notification) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        // dispatch({
        //     type: actions.CREATE_TASK_START
        // });
        const firestore = getFirestore();
        const profile = getState().firebase.profile
        const profileUid = getState().firebase.auth.uid

        firestore.collection(getCollection(profile, 'notifications')).add({
            ...notification,
            authorDisplayName: (profile.displayName || ''),
            authorId: profileUid,
            createdAt: new Date(),
        }).then((createdNotification) => {
            // dispatch({
            //     type: actions.CREATE_TASK_SUCCESS,
            //     payload: notification
            // });
        }).catch((err) => {
            // dispatch({
            //     type: actions.CREATE_TASK_ERROR,
            //     payload: err
            // })
        })
    }
}

export function addNotification(firestore, notification, profile) {
    firestore.collection(getCollection(profile, 'notifications')).add({
        ...notification,
        createdAt: new Date(),
        read: false,
        open: false
    })
}

export function addAdminNotification(firestore, notification, profile) {
    if (
        (notification.type == 'CompleteTask')
        ||
        (notification.type == 'AddTaskComment')
        ||
        (notification.type == 'ProjectClosed')
    ) {
        firestore.collection('users')
            .where('organization.id', '==', profile.organization && profile.organization.id)
            .where('role', '==', 'Admin')
            .get()
            .then((querySnapshot) => {
                const users = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id
                }));
                console.log("users : ", users)

                users.forEach(user => {
                    if (user.id != notification.from) {
                        firestore.collection(getCollection(profile, 'notifications')).add({
                            ...notification,
                            createdAt: new Date(),
                            to: user.id,
                            read: false,
                            open: false
                        });
                    }
                });

            }).catch((err) => {
                console.log("err : ", err);
            })

    } else {
        // debugger
    }
}